// Central site config for X20 Consulting marketing site.
export const CONSULT_EMAIL = "hello@x20-consulting.com";

// mailto link used by every "Free Consultation" CTA. Pre-fills a subject so
// inbound requests are easy to triage before a booking flow exists.
export const CONSULT_MAILTO =
  `mailto:${CONSULT_EMAIL}` +
  "?subject=" +
  encodeURIComponent("Free consultation — X20 Consulting") +
  "&body=" +
  encodeURIComponent(
    "Hi X20 team,\n\nWe'd like to book our free initial consultation.\n\n" +
      "What we're building / the problem:\n\n" +
      "Rough timeline:\n\n" +
      "Best way to reach us:\n",
  );

// mailto for the "Request a live demo" CTA — a guided, screen-shared demo of
// the live lending/CRE runtime (demo-on-request; we do not expose the gated
// dashboard publicly).
export const DEMO_MAILTO =
  `mailto:${CONSULT_EMAIL}` +
  "?subject=" +
  encodeURIComponent("Live demo request — X20 Agentic Platform") +
  "&body=" +
  encodeURIComponent(
    "Hi X20 team,\n\nWe'd like a live demo of the agentic platform running.\n\n" +
      "Our domain / the decisions we'd want it to handle:\n\n" +
      "Best times this week:\n\n" +
      "Best way to reach us:\n",
  );

// Unauthenticated track — shown to visitors (pairs with Login + Start Free).
export const PUBLIC_NAV_LINKS = [
  { name: "Capabilities", path: "/capabilities" },
  { name: "Feasibility Sprint", path: "/feasibility-sprint" },
  { name: "Platform", path: "/platform" },
  { name: "See It Live", path: "/live" },
  { name: "Proof", path: "/proof" },
  { name: "How We Work", path: "/how-we-work" },
  { name: "Built to Last", path: "/built-to-last" },
  { name: "About", path: "/about" },
];

// Authenticated track — shown once logged in (pairs with Logout).
// Includes the Engagement Scout dashboard (/engagements) - the BD agent
// suite's read model over the scout/screener/proposer pipeline - and the
// Agent Composer (/agent-composer), a search-and-compose hub over the
// AGENTCATALOG of every task-performing agent across the X20 / Fipsr
// workspace. Marketing pages are also reachable when logged in. (No
// "Home" entry — per x20 convention, the top-left X20 Consulting logo
// returns to home.)
export const AUTH_NAV_LINKS = [
  { name: "Agent Composer", path: "/agent-composer" },
  { name: "Engagement Scout", path: "/engagements" },
  { name: "Capabilities", path: "/capabilities" },
  { name: "Feasibility Sprint", path: "/feasibility-sprint" },
  { name: "Platform", path: "/platform" },
  { name: "See It Live", path: "/live" },
  { name: "Proof", path: "/proof" },
  { name: "How We Work", path: "/how-we-work" },
  { name: "Built to Last", path: "/built-to-last" },
  { name: "About", path: "/about" },
];
